import React, { useEffect, useState, useRef } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    Stack,
    Text,
    Box,
    Input,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Checkbox,
    useToast,
    Flex,
    Alert,
    AlertIcon
} from '@chakra-ui/react';
import ChangePasswordComponent from './ChangePasswordComponent';
import InviteUserComponent from './InviteUserComponent';
import EditTeamMemberModal from './EditTeamMemberModal'
import RevolutCheckout from "@revolut/checkout";

const ProfileModal = ({ isOpen, onClose, user, setUser }) => {
    const toast = useToast();
    const role = user?.role;

    const cardFieldRef = useRef();

    const [showCardInput, setShowCardInput] = useState(false);

    const [logoFile, setLogoFile] = useState(null);
    const [previewLogo, setPreviewLogo] = useState(
    user?.company?.logoUrl
        ? `${process.env.REACT_APP_BACKEND_URL}/api/auth/test-route?img=${user.company.logoUrl}`
        : ''
);

    const [showInvite, setShowInvite] = useState(false);
    const [teamMembers, setTeamMembers] = useState([]);
    const [editingUser, setEditingUser] = useState(null);
    const [isProfileReopen, setIsProfileReopen] = useState(false);
    const [showCardSavedAlert, setShowCardSavedAlert] = useState(false);
    const [invites, setInvites] = useState([]);

    const [showPasswordSection, setShowPasswordSection] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        surname: '',
        email: '',
        phone: '',
        companyName: '',
        registrationNumber: '',
        tradingName: '',
        accountsEmail: '',
        optionalEmail: '',
        cardLast4: '',
        cardBrand: '',
        cardExpiryMonth: '',
        cardExpiryYear: '',
    });

    useEffect(() => {
        if (isProfileReopen) {
            setTimeout(() => {
                onClose(false); // або виклич функцію, яка відкриває ProfileModal, залежно від логіки
                setIsProfileReopen(false);
            }, 100);
        }
    }, [isProfileReopen]);

    useEffect(() => {
        const fetchTeam = async () => {
            const token = localStorage.getItem('authToken');
            if (!token) return;

            try {
                const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/user/company-users`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                const data = await response.json();
                if (response.ok) setTeamMembers(data.team);
            } catch (err) {
                console.error('Failed to load team members', err);
            }
        };

        if (isOpen && (role === 'owner' || role === 'admin')) {
            fetchTeam();
        }
    }, [isOpen, role]);

    useEffect(() => {
        if (user) {
            setFormData({
                name: user.name || '',
                surname: user.surname || '',
                email: user.email || '',
                phone: user.phone || '',
                companyName: user.company?.companyName || '',
                registrationNumber: user.company?.registrationNumber || '',
                tradingName: user.company?.tradingName || '',
                optionalEmail: user.optionalEmail || ''
            });

            if (user.company?.logoUrl) {
                    setPreviewLogo(`${process.env.REACT_APP_BACKEND_URL}/api/auth/test-route?img=${user.company.logoUrl}`);
            }
        }
    }, [user, isOpen]);

    const [selectedUserIds, setSelectedUserIds] = useState([]);

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({ ...prev, [id]: value }));
    };

    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setLogoFile(file);
        }
    };

    const fetchInvites = async () => {
        try {
            const token = localStorage.getItem('authToken');
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/user/invite/list`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const data = await response.json();
            if (response.ok) {
                setInvites(data.invites);
            }
        } catch (err) {
            console.error('Error fetching invites:', err);
        }
    };

    useEffect(() => {
        if (user) {
            fetchInvites();
        }
    }, []);

    const handleUpdateCard = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/revolut/create-customer`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    name: `${formData.name} ${formData.surname}`,
                    email: formData.email,
                    phone: formData.phone
                })
            });

            const data = await res.json();
            if (!res.ok || !data.token) throw new Error('Token not received');
            setShowCardInput(true);

            setTimeout(async () => {
                const { createCardField } = await RevolutCheckout(data.token);
                const cardField = createCardField({
                    target: document.getElementById("card-field"),
                    onSuccess() {

                        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/revolut/get-payment-id?orderId=${data.orderId}&customerId=${data.customerId}`)
                            .then(res => res.json())
                            .then(cardData => {
                                if (cardData.paymentCardId) {
                                    // відправити на бекенд для оновлення картки компанії
                                    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/user/update-payment`, {
                                        method: 'PUT',
                                        headers: {
                                            'Content-Type': 'application/json',
                                            'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                                        },
                                        body: JSON.stringify({
                                            paymentCardId: cardData.paymentCardId,
                                            revolutCustomerId: cardData.revolutCustomerId
                                        })
                                    }).then(async  () => {
                                        toast({
                                            title: 'Company payment updated',
                                            status: 'success',
                                            variant: 'left-accent',
                                            duration: 3000,
                                            position: 'bottom-right'
                                        });
                                        setShowCardSavedAlert(true);
                                        setTimeout(() => setShowCardSavedAlert(false), 3000);
                                        setShowCardInput(false);

                                        const token = localStorage.getItem('authToken');
                                        const refreshedRes = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/me`, {
                                            method: 'GET',
                                            headers: {
                                                Authorization: `Bearer ${token}`
                                            }
                                        });
                                        const refreshed = await refreshedRes.json();
                                        if (refreshedRes.ok) {
                                            localStorage.setItem('authUser', JSON.stringify(refreshed));
                                            setUser(refreshed);
                                        }

                                    });
                                }
                            });
                    },
                    onError(err) {
                        toast({ title: 'Error', variant: 'left-accent', description: err.toString(), status: 'error', position: 'bottom-right' });
                    }
                });

                cardFieldRef.current = cardField;
            }, 100);
        } catch (err) {
            toast({ title: 'Error', description: err.message, variant: 'left-accent', status: 'error', position: 'bottom-right' });
        }
    };

    const handleSave = async () => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) throw new Error('User not authenticated');

            const form = new FormData();
            Object.entries(formData).forEach(([key, value]) => form.append(key, value));
            if (logoFile) form.append('logo', logoFile);

            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/user/profile/update`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                body: form
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.message || 'Update failed');

            toast({
                title: 'Profile updated',
                description: 'Your profile information was saved.',
                status: 'success',
                variant: 'left-accent',
                position: 'bottom-right',
                duration: 4000,
                isClosable: true
            });

            const refreshedRes = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/me`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            const refreshed = await refreshedRes.json();
            if (!refreshedRes.ok) throw new Error(refreshed.message || 'Failed to refresh user');
            localStorage.setItem('authUser', JSON.stringify(refreshed));
            setUser(refreshed);

            if (refreshed.company?.logoUrl) {
		    setPreviewLogo(`${process.env.REACT_APP_BACKEND_URL}/api/auth/test-route?img=${refreshed.company.logoUrl}`);
		}


            onClose();
        } catch (error) {
            toast({
                title: 'Update failed',
                description: error.message,
                status: 'error',
                variant: 'left-accent',
                position: 'bottom-right',
                duration: 4000,
                isClosable: true
            });
        }
    };

    const resendInvite = async (email) => {
        try {
            const token = localStorage.getItem('authToken');
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/user/invite`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({ email })
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Failed to resend invitation.');
            }
            toast({
                title: 'Invitation resent',
                description: `An invitation has been resent to ${email}`,
                status: 'success',
                variant: 'left-accent',
                position: 'bottom-right',
                duration: 4000,
                isClosable: true
            });

        } catch (err) {
            console.error('Error resending invite:', err);
        }
    };


    const handleCheckboxToggle = (id) => {
        setSelectedUserIds(prev => (prev.includes(id) ? [] : [id]));
    };

    const handleRemoveMembers = async () => {
        if (selectedUserIds.length === 0) return;
        if (!window.confirm('Are you sure you want to remove selected user(s)?')) return;

        try {
            const token = localStorage.getItem('authToken');
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/user/remove-team-member/`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ ids: selectedUserIds })
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.message || 'Failed to remove users');

            toast({
                title: 'Users removed',
                description: data.message,
                status: 'success',
                variant: 'left-accent',
                position: 'bottom-right',
                duration: 4000,
                isClosable: true
            });

            // Оновити список після видалення
            setTeamMembers(prev => prev.filter(member => !selectedUserIds.includes(member.id)));
            setSelectedUserIds([]);
        } catch (err) {
            toast({
                title: 'Removal failed',
                description: err.message,
                status: 'error',
                variant: 'left-accent',
                position: 'bottom-right',
                duration: 4000,
                isClosable: true
            });
        }
    };

    const handleDeleteAccount = async () => {
        const confirmed = window.confirm('Are you sure you want to delete your account? This will also delete your company and all team members.');
        if (!confirmed) return;

        try {
            const token = localStorage.getItem('authToken');
            if (!token) throw new Error('User not authenticated');

            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/user/delete-owner-account`, {
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.message || 'Failed to delete account');

            toast({
                title: 'Account Deleted',
                description: 'Your profile and company were deleted.',
                status: 'success',
                variant: 'left-accent',
                position: 'bottom-right',
                duration: 4000,
                isClosable: true
            });

            localStorage.removeItem('authToken');
            localStorage.removeItem('authUser');
            window.location.reload();

        } catch (error) {
            toast({
                title: 'Error',
                description: error.message,
                status: 'error',
                variant: 'left-accent',
                duration: 4000,
                isClosable: true
            });
        }
    };


    return (
        <>
            <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl" zIndex={99995}>
                <ModalOverlay />
                <ModalContent p={1} bg="white" containerProps={{ zIndex: '99995' }}>
                    <ModalHeader textAlign="center" fontWeight="bold">My Profile</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {user ? (
                            <Stack spacing={4}>
                                <Box>
                                    <Text><b>Name</b></Text>
                                    <Input id="name" value={formData.name} onChange={handleInputChange} />

                                    <Text mt={3}><b>Surname</b></Text>
                                    <Input id="surname" value={formData.surname} onChange={handleInputChange} />

                                    <Text mt={3}><b>Email</b></Text>
                                    <Input
                                        id="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        isDisabled={role !== 'owner'}
                                    />

                                    <Text mt={3}><b>Booking contact number</b></Text>
                                    <Input id="phone" value={formData.phone} onChange={handleInputChange} />

                                    {role === 'owner' && (
                                        <>
                                            <Text mt={3}><b>Company Registered Name</b></Text>
                                            <Input
                                                id="companyName"
                                                value={formData.companyName}
                                                readOnly
                                                onChange={handleInputChange}
                                                bg="gray.100"
                                                color="gray.600"
                                                borderColor="gray.300"
                                            />

                                            <Text mt={3}><b>Company Registration Number</b></Text>
                                            <Input
                                                id="registrationNumber"
                                                value={formData.registrationNumber}
                                                readOnly
                                                onChange={handleInputChange}
                                                bg="gray.100"
                                                color="gray.600"
                                                borderColor="gray.300"
                                            />

                                            <Text mt={3}><b>Trading Name</b></Text>
                                            <Input id="tradingName" value={formData.tradingName} onChange={handleInputChange} />

                                            <Text mt={3}><b>Company Logo</b></Text>
                                            {previewLogo && (
                                                <Box mt={2}>
                                                    <img src={previewLogo} alt="Logo Preview" style={{ height: '80px', objectFit: 'contain' }} />
                                                </Box>
                                            )}
                                            <Input
                                                type="file"
                                                accept="image/*"
                                                onChange={handleLogoChange}
                                                height="40px"
                                                padding="4px 8px"
                                                lineHeight="1.5"
                                                borderRadius="md"
                                                border="1px solid #ccc"
                                            />
                                        </>
                                    )}

                                    {(role === 'owner' || role === 'admin') && (
                                        <>
                                            <Text mt={3}><b>Accounts Email (where the payment receipt will be sent)</b></Text>
                                            <Input id="optionalEmail" value={formData.optionalEmail} onChange={handleInputChange} />
                                        </>
                                    )}
                                </Box>

                                {showPasswordSection ? (
                                    <ChangePasswordComponent
                                        onSuccess={() => setShowPasswordSection(false)}
                                        onCancel={() => setShowPasswordSection(false)}
                                    />
                                ) : (
                                    <Button
                                        width="100%"
                                        onClick={() => setShowPasswordSection(true)}
                                        fontWeight={600}
                                        variant="outline"
                                    >
                                        Change Password
                                    </Button>
                                )}


                                {(role === 'owner' || role === 'admin') && (
                                    <>

                                        <Text mt={3}><b>Update Payment Card</b></Text>
                                        {showCardSavedAlert && (
                                            <Box mt={3}>
                                                <Alert status="success" borderRadius="md" variant='left-accent'>
                                                    <AlertIcon />
                                                    Card successfully saved.
                                                </Alert>
                                            </Box>
                                        )}
                                        {user?.company?.cardBrand && user?.company?.cardLast4 && user?.company?.cardExpMonth && user?.company?.cardExpYear && (
                                            <Box
                                                mt={3}
                                                px={4}
                                                py={3}
                                                bg="gray.200"
                                                color="black"
                                                borderRadius="lg"
                                                boxShadow="md"
                                                fontSize="15px"
                                                maxW="320px"
                                            >
                                                <Flex justify="space-between" align="center" mb={2}>
                                                    <Box fontWeight="semibold">{user.company.cardBrand?.toUpperCase()}</Box>
                                                    <Box fontSize="lg" letterSpacing="2px">
                                                        **** {user.company.cardLast4}
                                                    </Box>
                                                </Flex>
                                                <Box fontSize="sm">
                                                    <Text opacity={0.7}>Expires</Text>
                                                    <Text fontWeight="medium">
                                                        {String(user.company.cardExpMonth).padStart(2, '0')}/{user.company.cardExpYear}
                                                    </Text>
                                                </Box>
                                            </Box>
                                        )}
                                        <Button variant="outline" width="100%" onClick={handleUpdateCard}>
                                            Update Card
                                        </Button>
                                        {showCardInput && (
                                            <>
                                                <div id="card-field" style={{ margin: '1rem 0' }}></div>
                                                <Button
                                                    id="button-submit"
                                                    width="100%"
                                                    type="button"
                                                    variant="outline"
                                                    fontWeight={600}
                                                    onClick={() => {
                                                        if (cardFieldRef.current) {
                                                            cardFieldRef.current.submit({
                                                                email: formData.accountsEmail,
                                                                name: `${formData.name} ${formData.surname}`,
                                                                savePaymentMethodFor: 'merchant'
                                                            });
                                                        }
                                                    }}
                                                >
                                                    Submit
                                                </Button>
                                            </>
                                        )}

                                        <Button
                                            width="100%"
                                            onClick={() => setShowInvite(prev => !prev)}
                                            variant="outline"
                                            fontWeight={600}
                                        >
                                            {showInvite ? 'Cancel Invite' : 'Invite User'}
                                        </Button>

                                        {showInvite && (
                                            <InviteUserComponent
                                                onSuccess={() => {
                                                    setShowInvite(false);
                                                    fetchInvites(); // після інвайту — оновлюємо список
                                                }}
                                            />
                                        )}
                                        <Text fontWeight="bold" mt={4} mb={2}>Pending Invitations</Text>
                                        <Table size="sm" variant="simple">
                                            <Thead>
                                                <Tr>
                                                    <Th>Email</Th>
                                                    <Th>Action</Th>
                                                </Tr>
                                            </Thead>
                                            <Tbody>
                                                {invites.map(invite => (
                                                    <Tr key={invite.id}>
                                                        <Td>{invite.email}</Td>
                                                        <Td>
                                                            <Button
                                                                size="md"
                                                                variant="outline"
                                                                onClick={() => resendInvite(invite.email)}
                                                            >
                                                                Resend
                                                            </Button>
                                                        </Td>
                                                    </Tr>
                                                ))}
                                            </Tbody>
                                        </Table>


                                    </>

                                )}

                                {(role === 'owner' || role === 'admin') && (
                                    <>
                                        <Box overflowX="auto">
                                            <Text fontWeight="bold" mb={2}>Team Members</Text>
                                            <Table size="sm" variant="simple">
                                                <Thead>
                                                    <Tr>
                                                        <Th></Th>
                                                        <Th>Name</Th>
                                                        <Th>Surname</Th>
                                                        <Th>Email</Th>
                                                        <Th>booking Phone</Th>
                                                        <Th>Role</Th>
                                                    </Tr>
                                                </Thead>
                                                <Tbody>
                                                    {teamMembers.map(member => (
                                                        <Tr key={member.id}>
                                                            <Td>
                                                                <Checkbox
                                                                    isChecked={selectedUserIds.includes(member.id)}
                                                                    onChange={() => handleCheckboxToggle(member.id)}
                                                                />
                                                            </Td>
                                                            <Td>{member.name}</Td>
                                                            <Td>{member.surname}</Td>
                                                            <Td>{member.email}</Td>
                                                            <Td>{member.bookingPhone || '-'}</Td>
                                                            <Td>{member.role}</Td>
                                                        </Tr>
                                                    ))}
                                                </Tbody>
                                            </Table>
                                        </Box>

                                        {role === 'owner' && (
                                            <Flex gap={3} flexWrap="wrap">
                                                <Button
                                                    onClick={() => {
                                                        const userToEdit = teamMembers.find(u => u.id === selectedUserIds[0]);
                                                        setEditingUser(userToEdit);
                                                        onClose();
                                                    }}
                                                    variant="outline"
                                                    fontWeight={600}
                                                    flex={1}
                                                    isDisabled={selectedUserIds.length === 0}
                                                >
                                                    Edit Member
                                                </Button>
                                                <Button
                                                    onClick={handleRemoveMembers}
                                                    variant="solid-red-btn"
                                                    fontWeight={600}
                                                    flex={1}
                                                    isDisabled={selectedUserIds.length === 0}
                                                >
                                                    Remove Member
                                                </Button>
                                            </Flex>
                                        )}
                                    </>
                                )}
                                {role === 'owner' && (
                                    <Button
                                        onClick={handleDeleteAccount}
                                        variant="solid-red-btn"
                                        fontWeight={600}
                                        width="100%"
                                        mt={4}
                                    >
                                        Delete My Account
                                    </Button>
                                )}
                            </Stack>
                        ) : (
                            <Text>You are not logged in.</Text>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={handleSave} variant="solid-green-btn" fontWeight={600} width="100%">
                            Save
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            <EditTeamMemberModal
                isOpen={!!editingUser}
                member={editingUser}
                onClose={() => {
                    setEditingUser(null);
                    setIsProfileReopen(true); // прапорець для повторного відкриття профілю
                }}
                onSave={() => {
                    setEditingUser(null);
                    setIsProfileReopen(true);
                }}
            />
        </>
    );
};

export default ProfileModal;
